import React, { useContext } from 'react'
import RightContent from 'modules/react/signup/RightContent'
import LeftContent from 'modules/react/signup/LeftContent'
import SignupContext from 'modules/react/signup/SignupContext'
import { default as CoursePlusContent } from 'modules/react/signup/course-plus/single-class/SignupContent'
import { default as SingleClassOrGSKContent } from 'modules/react/signup/gsk/SignupContent'
import Step1RightContent from './Step1RightContent'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'
import Step1RightContentDynamic from 'modules/react/signup/Step1RightContentDynamic'

export default function SignupContent () {
  const [signupType, setSignupType] = React.useState(null)

  const signupContext = useContext(SignupContext)

  const { goToNextStep, step, goToStep, setEnterCallback, useCustomRightContent, course} = signupContext

  React.useEffect(() => {
      setEnterCallback(() => goToNextStep)
    }, []
  )

  React.useEffect(() => {
    goToStep(0)
    if(course.course_types.length === 1) {
      setSignupType(course.course_types[0] === 'gsk' ? 'gs' : 'course_plus')
    }
  }, [])

  if (step === 0) {
    return (
      <>
        <LeftContent>
          <div className="title title--h3">Vælg gymnasial supplering eller enkelt-fag</div>
          <div className="wysiwyg">Her skal du vælge om du vil tilmeldes gymnasial supplering eller enkeltfag.
          </div>
          <div className="title title--h6">Vælg</div>
          <div className="radio-group radio-group--large-group">
            {
              course.course_types.includes('gsk') && (
                <div className="radio-button">
                  <input type="radio" value="gs" id="gs" name="signup_type"
                         defaultChecked={signupType === 'gs'}
                         onChange={(e) => setSignupType('gs')}/>
                  <label htmlFor="gs">Gymnasial supplering</label>
                </div>
              )
            }
            {
              course.course_types.includes('enkeltfag') && (
                <div className="radio-button">
                  <input type="radio" value="course_plus" id="course_plus" name="signup_type"
                         defaultChecked={signupType === 'course_plus'}
                         onChange={(e) => setSignupType('course_plus')}/>
                  <label htmlFor="course_plus">Enkeltfag</label>
                </div>
              )
            }
          </div>
          <div className="button-section button-section--modal-group">
            <button className="button button--next" onClick={goToNextStep} disabled={signupType === null}>
              Tag mig videre
            </button>
          </div>
        </LeftContent>
        <RightContent>
          {useCustomRightContent ? <Step1RightContentDynamic/> : <Step1RightContent/>}
        </RightContent>
      </>
    )
  }

  return (
    <>
      {signupType === 'course_plus' && (
        <CoursePlusContent withBackButton/>
      )}
      {signupType === 'gs' && (
        <SingleClassOrGSKContent withBackButton/>
      )}
    </>
  )
}